import styled from "styled-components";
import { COLORS } from "../../styles/constants.style";

export const ProjectSearchWrapper = styled.div`
  color: ${COLORS.cirrus_black};

  .MuiPopper-root {
    inset: 10px auto auto -50px !important;
  }
`;
